import { Injectable } from '@angular/core'
import { environment } from '@appEnv/environment'
import {VssApiService} from '../../../projects/vss-ui/src/vss-ui/services/vss-api.service';
import { PATH } from '@app/modules/shares/enum/constants'

@Injectable({
  providedIn: 'root'
})
export class BaseService extends VssApiService{
  baseUrl = environment.apiUrl
  // baseUrl = "http://10.110.10.183:10001"
  // path = '/api/v1/admin'
  path = PATH
  // baseUrl = environment.apiUrlCAM
  // path = '/api/v1/admin'
  adminPath = environment.contextPathAdmin
  contextPathNotify=environment.contextPathNotify
  contextPathAdmin=environment.contextPathAdmin
  contextPathOperate=environment.contextPathOperate
  contextPathDashboard=environment.contextPathDashboard
}
